import React from 'react';
import { useQualificationStructureUrl } from './routing';
import { Box, Typography } from '@mui/material';
import StructureComparison from './StructureComparison';
import { LinkButton } from 'framework/ui/ui-builder';

const QualificationStructurePageLayout = () => {
  const { getBuilderUrl, getStructureListUrl } = useQualificationStructureUrl();
  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between" mx={2} mt={3} mb={3}>
        <Typography variant="h1" color="brand">
          Qualification Structure Comparison
        </Typography>
        <Box display="flex" gap={1}>
          <LinkButton url={getBuilderUrl}>Builder</LinkButton>
          <LinkButton url={getStructureListUrl}>Target versions</LinkButton>
        </Box>
      </Box>
      <StructureComparison />
    </>
  );
};
export default QualificationStructurePageLayout;
